import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div``

const Image = styled.img`
  width: 100%;
  border-radius: ${sv.radius.large};
`

export default { Block, Image }
